import "./BadeMenu.scss";

import React from "react";

interface BadgeMenuProps {
  label: string;
  classCustom?: string;
}

const BadgeMenu: React.FC<BadgeMenuProps> = ({ label, classCustom }) => {
  return (
    <span className={`${classCustom || ""} badge-label`}>
      <span className="whitespace-nowrap text-[10px]">{label}</span>
    </span>
  );
};

export default BadgeMenu;
